import React from 'react';

import { DAILY_MESSAGE_LIMIT } from '~components/business-owner/barry/utils';

import { DisabledSendIcon, SendButtonIcon } from '~assets/images';

import styles from './BarryIndividualConversation.module.scss';

interface BarryMessageInputFormProps {
	messageInput: string;
	hasHitDailyLimit: boolean;
	isBarryBusy: boolean;
	onInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
	onSubmit: () => void;
}

export const BarryMessageInputForm: React.FC<BarryMessageInputFormProps> = (props) => {
	const {
		messageInput,
		hasHitDailyLimit,
		isBarryBusy,
		onInputChange,
		onKeyDown,
		onSubmit,
	} = props;

	if (hasHitDailyLimit) {
		return (
			<div className={styles.inputArea}>
				<div className={styles.limitReached}>
					<p>
						You&apos;ve reached your daily message limit of{' '}
						{DAILY_MESSAGE_LIMIT} messages.
					</p>
					<p>Your limit will reset tomorrow.</p>
				</div>
			</div>
		);
	}

	const isSendDisabled = messageInput.length === 0 || isBarryBusy;

	return (
		<div className={styles.inputArea}>
			<form className={styles.inputForm}>
				<div className={styles.inputContainer}>
					<input
						className={styles.messageInput}
						value={messageInput}
						onChange={onInputChange}
						placeholder="Send a message..."
						onKeyDown={onKeyDown}
					/>
					{isSendDisabled ? (
						<DisabledSendIcon />
					) : (
						<SendButtonIcon
							className={styles.sendButtonSmall}
							onClick={onSubmit}
							tabIndex={0}
						/>
					)}
				</div>
			</form>
		</div>
	);
};
